import { Button } from '@components/shared/Button/Button';
import Modal from '@components/shared/Modal/Modal';
import { useTexts } from 'utils/useTexts';

type AdditionalIncomeConfirmationModalProps = {
  isModalOpen: boolean;
  closeModal: () => void;
  handleAddMore: () => void;
  handleNoImDone: () => void;
};

const AdditionalIncomeConfirmationModal = ({
  isModalOpen,
  closeModal,
  handleAddMore,
  handleNoImDone,
}: AdditionalIncomeConfirmationModalProps) => {
  const { t } = useTexts();

  return (
    <Modal
      title={t('employmentAndIncome.addAdditionalIncome.title')}
      isOpen={isModalOpen}
      onClose={closeModal}
    >
      <p>{t('employmentAndIncome.addAdditionalIncome.expediteApplication')}</p>
      <ul className="iLendingCDX-modal-content__list">
        <li>
          <p>{t('employmentAndIncome.addAdditionalIncome.atLeast2Years')}</p>
        </li>
        <li>
          <p>{t('employmentAndIncome.addAdditionalIncome.otherIncomeSource')}</p>
        </li>
      </ul>

      <p>{t('employmentAndIncome.addAdditionalIncome.clickAddMore')}</p>

      <div className="iLendingCDX-modal-buttons">
        <Button
          variant="ghost"
          size="lg"
          className="iLendingCDX-modal-button__text"
          onClick={handleAddMore}
        >
          {t('employmentAndIncome.addAdditionalIncome.addMore')}
        </Button>
        <Button
          variant="ghost"
          size="lg"
          className="iLendingCDX-modal-button__text"
          onClick={handleNoImDone}
        >
          {t('employmentAndIncome.addAdditionalIncome.noImDone')}
        </Button>
      </div>
    </Modal>
  );
};

export default AdditionalIncomeConfirmationModal;
